<template>
    <div class="flex ml-0 flex-column w-full md:w-1/3 lg:w-1/3 pb-2">

        <h3>{{ $t('admin.apps.platform.android.title') }}</h3>

        <vs-input class="border-grey-light w-full" type="string" v-model="android.bundle"
                  :label="$t('admin.apps.platform.bundle')" required />

        <vs-input 
            class="border-grey-light w-full" 
            type="string" 
            v-model="android.min_app_version"
            :label="$t('admin.apps.platform.min_version')" 
            required 
            :danger="!isValidAppVersion(android.min_app_version)"
            danger-text="Invalid format"
        />

        <vs-input 
            class="border-grey-light w-full" 
            type="string" 
            v-model="android.current_app_version"
            :label="$t('admin.apps.platform.current_version')" 
            required
            :danger="!isValidAppVersion(android.current_app_version)"
            danger-text="Invalid format"
        />

        <vs-input class="border-grey-light w-full" type="string" v-model="android.store_link"
                  :label="$t('admin.apps.platform.google_play_link')" required />


        <h3 class="mt-8">{{ $t('admin.apps.platform.ios.title') }}</h3>

        <vs-input class="border-grey-light w-full" type="string" v-model="ios.bundle"
                  :label="$t('admin.apps.platform.bundle')" required />

        <vs-input 
            class="border-grey-light w-full" 
            type="string" 
            v-model="ios.min_app_version"
            :label="$t('admin.apps.platform.min_version')" 
            required
            :danger="!isValidAppVersion(ios.min_app_version)"
            danger-text="Invalid format"
        />

        <vs-input 
            class="border-grey-light w-full" 
            type="string" 
            v-model="ios.current_app_version"
            :label="$t('admin.apps.platform.current_version')" 
            required
            :danger="!isValidAppVersion(ios.current_app_version)"
            danger-text="Invalid format"
        />

        <vs-input class="border-grey-light w-full" type="string" v-model="ios.store_link"
                  :label="$t('admin.apps.platform.apple_store_link')" required />

        <vs-input class="border-grey-light w-full" type="string" v-model="ios.watch_bundle"
                  v-if="hasWatch"
                  :label="$t('admin.apps.platform.watch_bundle')" required />

        <Combobox
            class="mt-4"
            :label="$t('admin.apps.platform.apple_account_id')"
            :options="appleAccounts.map(appleAccount => ({key: parseInt(appleAccount.id), text: `${appleAccount.team_name} (${appleAccount.team_id})` }))"
            :value="ios.apple_account_id"
            :multiple="false"
            @input="handleAppleAccountChange"
        />

    </div>
</template>

<script>
import Combobox from "@/modules/Shared/Components/Combobox.vue";
import loader from "@/modules/Shared/Mixins/loader";
import ApplicationService from "@/modules/Admin/Services/ApplicationService";
import AppleAccountService from "@/modules/Admin/Services/AppleAccountService";
import {unifyPaginatedResponse} from "@/modules/Shared/Helpers/apiResponseHelper";
import PaginationService from "@/modules/Shared/Services/PaginationService";
import { appVersionValidation } from '@/modules/Shared/Helpers/validationHelper';

export default {
  name: "PlatformSettings",
  components: { Combobox },
  mixins: [loader],
  data() {
    return {
        appleAccounts: [],
        android: {
            bundle: '',
            min_app_version: '',
            current_app_version: '',
            store_link: '',
        },
        ios: {
            bundle: '',
            min_app_version: '',
            current_app_version: '',
            store_link: '',
            apple_account_id: '',
            watch_bundle: '',
        },
        hasWatch: false,
    }
  },
  async created() {
    await this.loadAndIgnoreError(async () => {
        const [android, ios, appleAccounts] = await Promise.allSettled([
            ApplicationService.getPlatform(this.$route.params.uuid, 'android'),
            ApplicationService.getPlatform(this.$route.params.uuid, 'ios'),
            unifyPaginatedResponse(AppleAccountService.getAppleAccounts, PaginationService.parseParameters({
                per_page: 30
            }))
        ])

        if (appleAccounts.status === 'fulfilled') {
            this.appleAccounts = appleAccounts.value
        }

        if (android.status === 'fulfilled') {
            this.android = android.value
        }

        if (ios.status === 'fulfilled') {
            this.ios = ios.value
        }

        await this.loadWatchModule()
    })
  },
  methods: {
    async onActive() {
        await this.loadWatchModule()
    },
    async loadWatchModule() {
        try {
            const modules = await ApplicationService.getApplicationModules(this.$route.params.uuid)
            this.hasWatch = !!modules.find(module => module.type.name === 'watch')
        } catch ($ex) {
            this.hasWatch = false
        }
    },
    isValidAppVersion(version) {
        return appVersionValidation(version)
    },
    handleAppleAccountChange(value) {
        this.ios.apple_account_id = value
    },
    save() {
        return new Promise(async (resolve, reject) => {
            this.loadAndNotifyError(async () => {
                try {
                    const applicationUuid = this.$route.params.uuid
                    await ApplicationService.updatePlatform(applicationUuid, 'android', this.android)
                    await ApplicationService.updatePlatform(applicationUuid, 'ios', this.ios)
                    resolve()
                } catch {
                    reject()
                    return
                }
            })
        })
    }
  }
};
</script>
